export default "/img/LK.2a377e32a33cd5136ba5e9907abd600e.png";